import { Guid } from '../../../../store/model/guid';
import { isSequencedFlowItem, Section, SequencedFlowItem } from '@ael/core-api';
import * as Immutable from 'immutable';

export const findSection = (
  needle: Section | SequencedFlowItem,
  item: Section | SequencedFlowItem,
  getSubsections: (item: SequencedFlowItem | Section) => Section[] | null
): Immutable.List<Guid> | null => {
  if (isSequencedFlowItem(needle)) {
    return null;
  }
  let result = null;
  const setResult = (breadCrumbs: Immutable.List<Guid>) => (result = breadCrumbs);

  searchInner(needle, item, Immutable.List<Guid>(), setResult, getSubsections);
  return result;
};

const searchInner = (
  needle: Section,
  item: Section | SequencedFlowItem,
  breadcrumbs: Immutable.List<Guid>,
  setResult: (breadcrumbs: Immutable.List<Guid>) => void,
  getSubsections: (item: SequencedFlowItem | Section) => Section[] | null
): boolean => {
  const subsections = getSubsections(item);
  if (!subsections) {
    return false;
  }

  if (subsections.findIndex((subsection) => subsection === needle) > -1) {
    setResult(breadcrumbs);
    return true;
  }
  return !!subsections.find((section: Section) => {
    const updatedBreadcrumbs = breadcrumbs.push(section.id);
    return searchInner(needle, section, updatedBreadcrumbs, setResult, getSubsections);
  });
};
